// extracted by mini-css-extract-plugin
module.exports = {"noop":"CustomerInvoiceNotes_noop__1meUj","invoiceNotesHeader":"CustomerInvoiceNotes_invoiceNotesHeader__3mFm4","editSaveIcon":"CustomerInvoiceNotes_editSaveIcon__3WMGm"};